import React from "react";
import POIsPositionsHeadPopups from "./POIsPositionsHeadPopups";
import POIsPositionBodyPopups from "./POIsPositionBodyPopups";

export default function POIsPositionsPopups({ data, setMapId }) {
	const lang = localStorage.getItem("lang") || "en";
	return (
		<>
			<div
				className={`device-popup ${
					lang === "en" ? "device-popup-ltr" : "device-popup-rtl"
				}`}
			>
				<POIsPositionsHeadPopups data={data} />
				<POIsPositionBodyPopups data={data} setMapId={setMapId} />
			</div>
		</>
	);
}
